var map = {
	"./co-kupowac-sztabki-czy-monety.md": [
		"bb3b",
		"chunk-2d21a3c5"
	],
	"./co-to-jest-moneta-bulionowa.md": [
		"252f",
		"chunk-2d0b28ed"
	],
	"./co-to-jest-patyna.md": [
		"de02",
		"chunk-2d229739"
	],
	"./jak-sprzedac-zloto.md": [
		"4955",
		"chunk-2d0c20db"
	],
	"./jakie-monety-kupowac-w-2020.md": [
		"136c",
		"chunk-2d0aad85"
	],
	"./kryzys-gospodarczy.md": [
		"3f69",
		"chunk-2d0c558c"
	],
	"./monety-bulionowe-a-kolekcjonerskie-roznice.md": [
		"8ad5",
		"chunk-2d0e8e30"
	],
	"./rabat-od-mennicy-gdanskiej.md": [
		"ef10",
		"chunk-2d230f76"
	],
	"./sposoby-falszowania-zlotych-i-srebrnych-monet.md": [
		"13e7",
		"chunk-2d0ab30a"
	],
	"./test-article.md": [
		"76a5",
		"chunk-2d0d7809"
	],
	"./wszystko-co-musisz-wiedziec-by-kupowac-monety-inwestycyjne.md": [
		"3c2f",
		"chunk-2d0c49fa"
	],
	"./zardzewiale-zloto.md": [
		"710b",
		"chunk-2d0d5f82"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ffe3";
module.exports = webpackAsyncContext;